<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/bJQ7yD/tc-custom/9780814737262.jpg?1721057597625" alt="This image is the cover for the book Victory Girls, Khaki-Wackies, and Patriotutes"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Victory Girls, Khaki-Wackies, and Patriotutes
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A study of how the U.S. government’s World War II fight against venereal disease transformed into a war against women.</b></p><p><i>Victory Girls, Khaki-Wackies, and Patriotutes</i> offers a counter-narrative to the story of Rosie the Riveter, the icon of female patriotism during World War II. With her fist defiantly raised and her shirtsleeves rolled up, Rosie was an asexual warrior on the homefront. But thousands of women supported the war effort not by working in heavy war industries, but by providing morale-boosting services to soldiers, ranging from dances at officers’ clubs to more blatant forms of sexual services, such as prostitution. While the de-sexualized Rosie was celebrated, women who used their sexuality—either intentionally or inadvertently—to serve their country encountered a contradictory morals campaign launched by government and social agencies, which shunned female sexuality while valorizing masculine sexuality. This double-standard was accurately summed up by a government official who dubbed these women “patriotutes”: part patriot, part prostitute. </p><p><br/> Marilyn E. Hegarty explores the dual discourse on female sexual mobilization that emerged during the war, in which agencies of the state both required and feared women’s support for, and participation in, wartime services. The equation of female desire with deviance simultaneously over-sexualized and desexualized many women, who nonetheless made choices that not only challenged gender ideology but defended their right to remain in public spaces. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Marilyn E Hegarty
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      NEW YORK UNIVERSITY PRESS
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?30e0fb90